import api from '../conf/ruta-base'
import axios from 'axios'
import store from "../store";
import aggregateHeaders from './headers';
import router from "../router";

// 1. Creamos una única instancia
const clientHttp = axios.create({
    baseURL: api.api
})

// 2. Interceptor de Request (Entrada)
clientHttp.interceptors.request.use(
    async (config) => {
        // Solo activamos el loading si NO es silencioso
        if (!config.silent) {
            store.commit("loading", true);
        }

        config.headers = config.headers || {};
        await aggregateHeaders(config);

        // Console log condicional para no ensuciar tanto la consola si es silent (opcional)
        if (!config.silent) console.log("AXIOS: config", config);

        return config;
    },
    function (error) {
        // En error de request (antes de salir), cerramos loading por seguridad
        // salvo que sea silent
        if (!error.config?.silent) {
            store.commit("loading", false);
        }
        return Promise.reject(error);
    }
);

// 3. Interceptor de Response (Salida)
clientHttp.interceptors.response.use(
    (response) => {
        // Lógica de cierre de loading:
        // No cerrar si es silent (porque nunca se abrió)
        // No cerrar si keepLoading es true (porque tú lo cerrarás manual)
        if (!response.config.silent && !response.config.keepLoading) {
            store.commit("loading", false);
        }
        return response;
    },
    function (error) {
        const originalRequest = error.config || {};

        // Manejo del Refresh Token
        if (
            (error.response?.status === 401 || error.response?.status === 403) &&
            originalRequest.url === "/auth/refresstoken"
        ) {
            sessionStorage.removeItem("token");
            store.commit("loading", false); // Aquí forzamos cierre siempre por seguridad (logout)
            router.push("login");
            return Promise.reject(error);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            sessionStorage.token = sessionStorage.getItem("refress_token")

            // Usamos la misma instancia clientHttp para reintentar
            return clientHttp
                .get("/auth/refresstoken", { silent: true }) // Importante: el refresh que sea silent
                .then((res) => {
                    if (res.status === 200) {
                        sessionStorage.token = res.data.access_token;
                        clientHttp.defaults.headers.common['Authorization'] = "Bearer " + res.data.access_token;

                        // Actualizamos el header del request original
                        originalRequest.headers['Authorization'] = "Bearer " + res.data.access_token;

                        return clientHttp(originalRequest);
                    } else {
                        store.commit("loading", false);
                        router.push("login");
                    }
                })
        }

        // Si falló y no era silent ni keepLoading, cerramos el loading
        // Nota: Si hubo error, generalmente queremos quitar el loading para que la pantalla no se congele,
        // incluso si pusiste keepLoading. Pero si quieres mantenerlo estricto, usa la misma condición que en success.
        if (!originalRequest.silent && !originalRequest.keepLoading) {
            store.commit("loading", false);
        }

        return Promise.reject(error);
    }
);

export default clientHttp;